const COURSE_ROUTES = [
  [/koine|greek/i, 'greek-course'],
  [/ancient[_-]?hebrew|hebrew/i, 'hebrew-course'],
  [/paleo/i, 'paleo-hebrew-course'],
  [/amharic/i, 'amharic-course'],
  [/aramaic/i, 'aramaic-course'],
  [/hermeneutic/i, 'hermeneutics-course'],
  [/kings[_-]?of[_-]?israel/i, 'kings-of-israel-course'],
  [/church[_-]?history/i, 'church-history-course'],
  [/textual[_-]?criticism/i, 'textual-criticism-course'],
  [/apologetic/i, 'apologetics-course'],
  [/canon/i, 'biblical-canon-course'],
  [/world[_-]?religion/i, 'world-religions-course'],
  [/archaeolog/i, 'biblical-archaeology-course'],
  [/feast/i, 'feast-days-course'],
  [/second[_-]?temple/i, 'second-temple-judaism-course'],
  [/pneumatolog/i, 'pneumatology-course'],
  [/christolog/i, 'christology-course'],
  [/old[_-]?testament[_-]?survey/i, 'old-testament-survey-course'],
  [/new[_-]?testament[_-]?survey/i, 'new-testament-survey-course'],
  [/textual[_-]?transmission/i, 'textual-transmission-course'],
  [/biblical[_-]?ethics/i, 'biblical-ethics-course'],
  [/argumentation/i, 'argumentation-course'],
  [/eschatolog/i, 'eschatology-course']
];

const COURSE_REQUIREMENTS = {
  'greek-course': { name: 'Koine Greek', points: 800 },
  'hebrew-course': { name: 'Ancient Hebrew', points: 800 },
  'paleo-hebrew-course': { name: 'Paleo-Hebrew', points: 800 },
  'amharic-course': { name: 'Amharic', points: 800 },
  'aramaic-course': { name: 'Aramaic', points: 800 },
  'hermeneutics-course': { name: 'Hermeneutics', points: 800 },
  'church-history-course': { name: 'Church History', points: 800 },
  'kings-of-israel-course': { name: 'Kings of Israel', points: 800 },
  'textual-criticism-course': { name: 'Textual Criticism', points: 800 },
  'apologetics-course': { name: 'Apologetics', points: 800 },
  'feast-days-course': { name: 'Biblical Feast Days', points: 500 }
};

const DEFAULT_REQUIREMENT = { points: 1000 };

export function resolveAcademyView(citation = {}) {
  const haystack = `${citation.source || ''} ${citation.label || ''} ${citation.title || ''}`;
  return COURSE_ROUTES.find(([pattern]) => pattern.test(haystack))?.[1] || 'academy-about';
}

export function getAcademyCitationAccess(citation = {}, userData = {}) {
  const courseId = resolveAcademyView(citation);
  if (courseId === 'academy-about') return { courseId, unlocked: true, name: citation.title || 'Sword Drill Academy' };
  const requirement = { ...DEFAULT_REQUIREMENT, ...(COURSE_REQUIREMENTS[courseId] || {}) };
  return {
    courseId,
    unlocked: Boolean(userData?.unlockables?.[`course_${courseId}`]),
    name: requirement.name || String(citation.title || courseId).replace(/-/g, ' '),
    requiredPoints: requirement.points
  };
}

export function decorateAcademyCitations(citations = [], userData = {}) {
  return citations.map((citation) => citation.type === 'academy'
    ? { ...citation, ...getAcademyCitationAccess(citation, userData) }
    : citation);
}

export default resolveAcademyView;
